const gatewayPrefix = {
  /**工单 */
  workorder: 'workorder',
  /**工单 */
  // workorder: '/192.168.30.181:8080/workorder-hsb',
  /**商品中心 */
  productcenter: 'productcenter',
};
export default gatewayPrefix;



// WEBPACK FOOTER //
// ./xcloud-client-components-web/utils/gatewayPrefix.js